import { miniApp } from '@tma.js/sdk-react'

/**
 * Закрыть Mini App. Нужно экрану «Откройте приложение заново»: свежую
 * подпись `initData` даёт только перезапуск, а перезапуск начинается с
 * закрытия. Старый клиент без метода просто остаётся на экране — текст
 * объясняет, что сделать руками.
 */
export const closeMiniApp = (): boolean => miniApp.close.ifAvailable().ok
